/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// material
import { SelectableList } from '@insticator/insticator-ui'; // iui-material
import ConfigController from 'material/expandablesection/controllers/configcontroller/configcontroller';
import ExpandableSection from 'material/expandablesection/expandablesection';
import SectionDescription from 'material/expandablesection/sectiondescription/sectiondescription';
import SectionCard from 'material/expandablesection/sectioncard/sectioncard';
import SectionGroup from 'material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription from 'material/expandablesection/sectiongroupdescription/sectiongroupdescription'
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/configuration/avatarsection/avatarsection_styles';
// action
import { updateAvatarPack } from 'state/actions/commentingState/configurationStatus';

const AVATOR_PACK_OPTS = [
  { value: 'DEFAULT', text: 'Default' },
  { value: 'NEWS', text: 'News' },
  { value: 'SPORTS', text: 'Sports' },
  { value: 'FINANCE', text: 'Finance' },
  { value: 'MOVIE', text: 'Movie' }
];
const renderImageNum = [
  ['1', '2', '3', '4'],
  ['5', '6', '7', '8'],
  ['9', '10', '11', '12']
  // ['13', '14', '15', '16']
];

const AvatarPreview = ({ avatarPack }) => {
  return (
    <span className={'avatarpreviewwrapper'}>
      {["1", "2", "3", "4", "5", "6"].map(i =>
        <img alt="" key={i} src={`${url.static.url}/avatars-v2/${avatarPack.toLowerCase()}-${i}.svg`} />
      )}
    </span>
  )
}
const AvatarSection = (props) => {
  const savedUserAvatarPack = useSelector(({ commentingState }) => commentingState.configStatus.avatarPack);
  const savingUserAvatarpack = useSelector(({ commentingState }) => commentingState.configStatus.savingAvatarPack);
  const commentingUnitConfigurationUUID = useSelector(({ commentingState }) => commentingState.configStatus.commentingUnitConfigurationUUID);

  const [avatarPack, setAvatarPack] = useState(savedUserAvatarPack);
  const [isOpened, setIsOpened] = useState(false);

  const dispatch = useDispatch();

  const collapse = () => {
    setIsOpened(false);
  }

  const handleAvatarPackSave = () => {
    if (savedUserAvatarPack !== avatarPack) {
      const avatarpack = { 'avatarPack': avatarPack };
      dispatch(updateAvatarPack(commentingUnitConfigurationUUID, avatarpack, collapse));
    }
  }

  const handleCancel = () => {
    setAvatarPack(savedUserAvatarPack);
  }

  const avatorPackName = useMemo(() => {
    const selectedAvatar = AVATOR_PACK_OPTS.find(i => i.value === savedUserAvatarPack);
    return `${selectedAvatar.text} pack`
  }, [savedUserAvatarPack])

  const controller = (
    <ConfigController
      isOpened={isOpened}
      setIsOpened={setIsOpened}
      handleCancel={handleCancel}
      handleSave={handleAvatarPackSave}
      processing={savingUserAvatarpack}
      disableSave={avatarPack === savedUserAvatarPack}
      title='User Avatars'
      description={<SectionDescription
        main={avatorPackName}
        content={
          <div className={'avatarpreview'}>
            <AvatarPreview avatarPack={savedUserAvatarPack} />
          </div>
        }
      />}
    />
  );

  return <ExpandableSection
    className={`avatarsection ${props.classes.avatarsection}`}
    controller={controller}
    isOpened={isOpened}
    setIsOpened={setIsOpened}
    processing={savingUserAvatarpack}
    handleCancel={handleCancel}
    handleSave={handleAvatarPackSave}
    disableSave={avatarPack === savedUserAvatarPack}
  >
    <div className={'avatarconfig'}>
      <SectionCard>
        <div className={'content'}>
          <SectionGroup>
            <SectionGroupDescription
              title='Avatar pack'
              description='Choose from different styles of user avatars. They are assigned to anonymous users and logged in users without a profile picture.'
            />
            <div className={'controls'}>
              <SelectableList type={'fancyradio'}
                items={AVATOR_PACK_OPTS}
                selected={avatarPack}
                handleChange={(value) => setAvatarPack(value)}
              />
            </div>
          </SectionGroup>
        </div>
      </SectionCard>
    </div>

    <div className={'avatarpreview'}>
      <SectionCard>
        <div className={'avatarcontainer'}>
          {!(avatarPack && Object.keys(avatarPack).length === 0 && avatarPack.constructor === Object) && avatarPack ?
            renderImageNum.map((imgNumArray, i) => {
              return <div className={'avatarset'} key={i}>
                {imgNumArray.map((imgNum, i) => {
                  return <img alt="" key={i} src={`${url.static.url}/avatars-v2/${avatarPack.toLowerCase()}-${imgNum}.svg`} />
                })}
              </div>
            }) : null}
        </div>
      </SectionCard>
    </div>
  </ExpandableSection>
}

export default injectSheet(styles)(AvatarSection)